import { render, staticRenderFns } from "./instance.vue?vue&type=template&id=fbd9efe6&scoped=true"
import script from "./instance.vue?vue&type=script&lang=js"
export * from "./instance.vue?vue&type=script&lang=js"
import style0 from "./instance.vue?vue&type=style&index=0&id=fbd9efe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd9efe6",
  null
  
)

export default component.exports